import React from 'react';
import { Radio } from 'antd';
import { RadioContainer } from 'components/Radio/RadioContainer';
import { ReactComponent as CheckmarkIcon } from 'style/_assets/icons/checkmark.svg';
import './RadioCardGroup.scss';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';

const RadioCardGroup = props => {
  const datatestid = props.datatestid ? props.datatestid : null;
  const radioButtonGroupClass = classnames(
    'RadioButtonGroup',
    props.radioGroupClass,
  );

  return (
    <RadioContainer
      datatestid={datatestid}
      className={radioButtonGroupClass}
      value={props.value}
      onChange={props.onChange}
    >
      {props.children}
    </RadioContainer>
  );
};

RadioCardGroup.RadioCard = ({
  icon: Icon,
  value,
  cardType,
  datatestid,
  noCheck,
  disabled,
  iconAlt,
  isVertical,
  radioCardClass,
  ...props
}) => {
  const showCheckMark = !noCheck && cardType !== 'button';
  const radioWrapperClass = classnames(
    'RadioCard',
    cardType,
    isVertical ? 'is-vertical' : '',
    radioCardClass,
  );
  const radioContainerClass = classnames(
    'icon-text-container content-align-center items-align-center',
    isVertical ? 'flex-column' : '',
  );

  return (
    <Radio.Button
      value={value}
      datautestid={datatestid ? datatestid : null}
      className={radioWrapperClass}
      disabled={disabled}
    >
      <FlexContainer
        datatestid={datatestid ? `${datatestid}-container` : null}
        className="radio-container justify-between items-align-center"
      >
        <FlexContainer className={radioContainerClass}>
          {Icon && (
            <FlexContainer className="iconContainer margR16">
              <Icon
                className="icon"
                data-testid={datatestid ? `${datatestid}-icon` : null}
                alt={iconAlt}
              />
            </FlexContainer>
          )}
          {props.children && (
            <Label
              type="Subtitle-2"
              className="radioLabelText radio-text"
              datatestid={datatestid ? `${datatestid}-text` : null}
            >
              {props.children}
            </Label>
          )}
        </FlexContainer>
        {showCheckMark && (
          <CheckmarkIcon
            className="check"
            data-testid={datatestid ? `${datatestid}-checkIcon` : null}
            aria-label="CheckmarkIcon"
          />
        )}
      </FlexContainer>
    </Radio.Button>
  );
};

export default RadioCardGroup;
